import { useEffect, useRef } from 'react';

/**
 * Renders a ghost of the cildren and calculates the largest child's height.
 * Once calculated, calls the onCalculated callback with the result.
 *
 * Can later be extended to calculate the width or lowest values as well.
 */
type MaxHeightCalcWrapperProps = {
  children: React.ReactNode;
  onCalculated: (height: number) => void;
};

const MaxHeightCalcWrapper = ({
  children,
  onCalculated,
}: MaxHeightCalcWrapperProps) => {
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!containerRef.current) return;
    if (!containerRef.current.children) return;

    const childNodes = containerRef.current.children;
    let maxChildHeight = 0;

    for (let i = 0; i < childNodes.length; i++) {
      const childHeight = childNodes[i].clientHeight;
      if (childHeight > maxChildHeight) {
        maxChildHeight = childHeight;
      }
    }

    onCalculated(maxChildHeight);
  }, [children]);

  return (
    <div
      aria-hidden // make sure it's invisible to screen readers
      ref={containerRef}
      style={{ visibility: 'hidden', position: 'absolute', top: 0, left: 0 }}
    >
      {children}
    </div>
  );
};

export default MaxHeightCalcWrapper;
